module.exports = __webpack_public_path__ + "img/20170319-10-768x1024.1b3920f6.jpeg";